import "core-js/modules/es.object.assign";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.iterator";
/* global Weglot */

/**
 * Component: Redirect modal
 * ------------------------------------------------------------------------------
 * Redirect modal configuration for complete theme support.
 * - https://github.com/Shopify/theme-scripts/tree/master/packages/theme-sections
 *
 * @namespace redirectModal
 */

import Cookies from 'js-cookie';
import { updateTabindexOnElement } from '~/helpers/a11y';
import cssClasses from '~/helpers/cssClasses';
import Currency from '~/helpers/currency';
import Redirects from '~/helpers/redirects';
import { formToJSON, getQueryParamsObject, on, serialize, updateWeglotSelectorOption } from '~/helpers/utils';
import Modal from '~/components/modal';
/**
 * DOM selectors.
 */

const selectors = {
  choiceContainer: '[js-redirect-modal="choiceContainer"]',
  choiceContinue: '[js-redirect-modal="choiceContinue"]',
  close: '[js-redirect-modal="close"]',
  container: '[js-redirect-modal="container"]',
  countrySelector: '[js-redirect-modal="countrySelector"]',
  currencySelector: '[js-redirect-modal="currencySelector"]',
  footer: '[js-redirect-modal="footer"]',
  form: '[js-redirect-modal="form"]',
  languageSelector: '[js-redirect-modal="languageSelector"]',
  redirectLink: '[js-redirect-modal="redirectLink"]',
  returnButton: '[js-redirect-modal="returnButton"]',
  settingsButton: '[js-redirect-modal="settingsButton"]',
  settingsContainer: '[js-redirect-modal="settingsContainer"]',
  updateButton: '[js-redirect-modal="updateButton"]',
  weglotSelector: '[js-weglot-language-selector="selector"]'
};
/**
 * Attribute and data selectors.
 */

const dataSelectors = {
  redirectModal: 'js-redirect-modal'
};
/**
 * Instance cookies.
 */

const cookieSelector = {
  geolocation: 'redirect_geolocation',
  modal: 'redirect_modal',
  settings: 'redirect_store_settings'
};
/**
 * Instance events.
 */

const eventSelector = {
  geoIPErrorHandler: 'Redirect:geoIPErrorHandler',
  locationDetected: 'Redirect:locationDetected',
  matched: 'Redirect:isMatchedLocation',
  modalClose: 'Modal:Close:redirect-modal',
  modalShow: 'Modal:Show:redirect-modal',
  redirectIcon: 'Redirect:updateIcon',
  unmatched: 'Redirect:isUnmatchedLocation'
};
/**
 * Instance settings.
 */

const settings = {
  id: 'redirect-modal'
};
/**
 * HTML placeholder strings used in language settings.
 */

const placeholder = {
  currentStoreName: '%current_store_name%',
  redirectStoreCode: '%redirect_store_code%',
  redirectStoreName: '%redirect_store_name%',
  redirectStoreUrl: '%redirect_store_url%'
};
/**
 * Create a new redirect modal.
 */

export default (() => {
  /**
   * Instance globals.
   */
  const container = document.querySelector(selectors.container);
  const weglotSelector = document.querySelectorAll(selectors.weglotSelector);
  const modal = Modal({
    id: settings.id
  });
  /**
   * Initialise section objects.
   */

  function init() {
    let Weglot;
    modal.init();
    renderTemplates();
    setEventListeners();
    setEventBusListeners();
    setDefaultState();

    if (Weglot !== undefined) {
      setTimeout(() => {
        updateDefaultLanguageOption();
      }, 2000);
    }
  }
  /**
   * Hide choice panel if user has already dismissed the modal or made their selection.
   */


  function setDefaultState() {
    const queryParameters = getQueryParamsObject();

    if (queryParameters.loc && queryParameters.lang && queryParameters.cur) {
      handleParameterEvents(queryParameters);
      return;
    }

    if (typeof Cookies.get(cookieSelector.modal) === 'undefined') {
      return;
    }

    disableChoiceCards();
  }
  /**
   * Set event listeners.
   */


  function setEventBusListeners() {
    Frame.EventBus.listen(eventSelector.modalClose, () => handleCloseEvents());
    Frame.EventBus.listen(eventSelector.modalShow, element => handleOpenEvents(element));
    Frame.EventBus.listen(eventSelector.matched, () => disableChoiceCards());
    Frame.EventBus.listen(eventSelector.unmatched, () => {
      handleLocationParameterEvents();

      if (typeof Cookies.get(cookieSelector.modal) === 'undefined') {
        modal.show(settings.id);
        window.setTimeout(() => showChoicesView(), 500);
      }
    });
    Frame.EventBus.listen(eventSelector.locationDetected, response => {
      render(response);
      renderTemplates();
      setEventListeners();
    });
    Frame.EventBus.listen(eventSelector.geoIPErrorHandler, () => {
      disableChoiceCards();
      handleCloseEvents();
    });
  }
  /**
   * Update choice card template if stored settings exist.
   */


  function updateChoiceContinueCard() {
    if (typeof Cookies.getJSON(cookieSelector.settings) !== 'undefined') {
      document.querySelector(selectors.choiceContinue).innerHTML = getChoiceContinueTemplate(Cookies.getJSON(cookieSelector.settings));
    }
  }
  /**
   * Get continue choice card template using stored settings.
   * @param {Object} response - store settings cookie data submitted from form.
   * @returns {String}
   */


  function getChoiceContinueTemplate(response) {
    if (typeof response.loc === 'undefined') {
      return '';
    }

    return "\n      <span class=\"choice-card__icon flag-icon flag-icon-".concat(response.loc.toLowerCase(), "\"></span>\n        <span class=\"choice-card__label\">\n        ").concat(theme.redirect.choiceContinue.replace(new RegExp(placeholder.currentStoreName, 'g'), response.countryName), "\n      </span>\n    ");
  }
  /**
   * Set click events that switch between the two redirect views.
   */


  function setEventListeners() {
    on('click', container, event => handleClickEvents(event));
    on('submit', document.querySelector(selectors.form), event => handleFormSubmit(event));
    on('change', document.querySelector(selectors.countrySelector), event => handleCountryChange(event));
    on('change', document.querySelector(selectors.languageSelector), event => handleLanguageChange(event));
  }
  /**
   * Update clickout URL when language option change is detected
   */


  function handleLanguageChange(event) {
    const language = event.target.options[event.target.selectedIndex].value;

    if (Weglot !== undefined) {
      Weglot.switchTo(language);
      updateWeglotSelectorOption(weglotSelector);
    }

    updateButtonStoreUrl();
  }
  /**
   * Update clickout URL
   */


  function updateButtonStoreUrl() {
    const countrySelector = document.querySelector(selectors.countrySelector).options;
    const selectedCountry = countrySelector[countrySelector.selectedIndex].value;
    const matchingStore = Redirects().getMatchingStore(selectedCountry);
    const currentPage = window.location.pathname;
    document.querySelector(selectors.updateButton).dataset.storeUrl = "".concat(matchingStore.storeUrl + currentPage);
  }
  /**
   * Use event delegation on user click events on modal container.
   * @param {Object} event - Click event target on container.
   */


  function handleClickEvents(event) {
    if (isContinueBrowsingButton(event.target)) {
      handleContinueClick(event);
      return;
    }

    if (isViewSettingsButton(event.target)) {
      showSettingsView();
      return;
    }

    if (isReturnButton(event.target)) {
      showChoicesView();
      return;
    }

    if (isRedirectChoice(event.target)) {
      event.preventDefault();
      handleRedirectClick(event);
    }

    if (isCloseButton(event.target)) {
      event.preventDefault();
      handleCloseButtonEvent(event);
    }
  }
  /**
   * Update modal template to reflect store settings in user's cookie.
   * - Replace choice card templates.
   * - Update country selector and re-render options based on selected.
   */


  function renderTemplates() {
    /**
     * FR is being used in storeCode ternary condition because an EU
     * country code does not exist in country selector.
     */
    const storeCode = getDefaultStoreCode();
    const matchingStore = Redirects().getMatchingStore(storeCode);
    const selectedCurrency = theme.features.currencyConverter ? Currency().getDefaultCurrencyCode() : Shopify.currency.active;
    let storeOption = storeCode;

    if (window.location.href.includes('?loc=')) {
      if (window.location.href.split('?loc=')[1].substring(0, 3) === 'ROW') {
        storeOption = 'ROW';
      } else {
        storeOption = window.location.href.split('?loc=')[1].substring(0, 2);
      }
    }

    const matchingOption = [...document.querySelector(selectors.countrySelector).children].find(element => {
      return element.value === storeOption;
    });
    updateButtonStoreUrl();

    if (!matchingOption) {
      return;
    }

    document.querySelector(selectors.countrySelector).selectedIndex = matchingOption.index;
    updateOptions(matchingStore);
    updateChoiceContinueCard();
    updateSelectedCurrencyOption(selectedCurrency);
    updateSelectedLanguageOption();
  }
  /**
  * Update default language selected based on current language
  *
  */


  function updateDefaultLanguageOption() {
    const languageSelector = document.querySelector(selectors.languageSelector);
    const currentLanguage = Weglot.getCurrentLang();
    const optionKeys = Object.keys(languageSelector.options);

    if (!languageSelector.options) {
      return;
    }

    optionKeys.forEach((key, index) => {
      if (languageSelector[key].value !== currentLanguage) {
        return;
      }

      languageSelector.options.selectedIndex = index;
    });
  }
  /**
   * Handle settings form submission.
   * @param {Object} event - Form event.
   */


  function handleFormSubmit(event) {
    event.preventDefault();
    handleURLRedirection(document.querySelector(selectors.form));
  }
  /**
   * Main handler to redirect users to the correct store based on form selection.
   * - Set loading states and redirect user after form submission.
   * - Update data-store-url on form button.
   * - Use form data as query string.
   * @param {HTMLElement} form - Setting form element.
   */


  function handleURLRedirection(form) {
    const button = document.querySelector(selectors.updateButton);
    const {
      loc: selectedCountryCode
    } = formToJSON(form);
    const selectedCountry = getCountryNameFromCode(selectedCountryCode);
    setButtonLoadingState(button);
    /**
     * Check if user needs to be redirected to another store using current pathname.
     * - If not, then set a cookie and refresh the page.
     * - Otherwise, redirect the user to the correct store with query parameters.
     */

    window.setTimeout(() => {
      setButtonActiveState(button);
      Cookies.set(cookieSelector.modal, 'dismissed', {
        expires: 7
      });

      if (isUserRedirected(button)) {
        window.location = "".concat(button.dataset.storeUrl.replace(/\/$'/, ''), "?").concat(serialize(form));
        Cookies.remove(cookieSelector.settings);
        return;
      }

      window.location = "".concat(button.dataset.storeUrl.replace(/\/$'/, ''), "?").concat(serialize(form));
      Cookies.set(cookieSelector.settings, Object.assign(formToJSON(form), {
        countryName: selectedCountry
      }));
    }, 1500);
  }
  /**
   * Check if user will be redirected outside of current store.
   * @param {String} redirectUrl - The url dynamically generated in the form submit button.
   * @returns {Boolean}
   */


  function isUserRedirected(button) {
    const {
      storeUrl,
      countryCode,
      currentCountry
    } = button.dataset;
    let redirect = window.location.origin !== storeUrl.replace(/\/$/, '');
    window.Frame.MultiStore.forEach(store => {
      if (store.storeCode === currentCountry) {
        if (store.supportedStores.includes(countryCode)) {
          redirect = false;
        }
      }
    });
    return redirect;
  }
  /**
   * Handle change events from country selector
   * @param {Object} event - Change event from selector.
   */


  function handleCountryChange(event) {
    const selectedOption = event.target.options[event.target.selectedIndex];
    const matchingStore = Redirects().getMatchingStore(selectedOption.value);
    updateOptions(matchingStore);
  }
  /**
   * Render new options in language and currency selector.
   * @param {Object} store - Store object from multi-store config.
   */


  function updateOptions(store) {
    const languageSelector = document.querySelector(selectors.languageSelector);
    const currencySelector = document.querySelector(selectors.currencySelector);
    const updateButton = document.querySelector(selectors.updateButton);
    const currentPage = window.location.pathname;
    const supportedCurrencies = getSupportedCurrencyValues(store);
    const storeCode = getDefaultStoreCode();
    const defaultCurrency = supportedCurrencies.indexOf(store.defaultCurrency);
    languageSelector.innerHTML = getOptionTemplate(store.supportedLanguages.split(', '), store.supportedLanguagesCodes.split(', '));
    currencySelector.innerHTML = getOptionTemplate(getSupportedCurrencies(store), getSupportedCurrencyValues(store));

    if (store.storeCode === storeCode) {
      document.querySelector(selectors.currencySelector).selectedIndex = supportedCurrencies.indexOf(theme.currency);
    } else {
      document.querySelector(selectors.currencySelector).selectedIndex = defaultCurrency;
    }

    updateButton.dataset.storeUrl = "".concat(store.storeUrl + currentPage);
  }
  /**
   * Returns the supported currencies for the store.
   * @param {Object} store - Store object from multi-store config.
   * @returns {Array}
   */


  function getSupportedCurrencies(store) {
    if (theme.features.currencyConverter) {
      return store.supportedCurrencies.split(', ');
    }

    const storeCode = getDefaultStoreCode();

    if (store.storeCode === storeCode) {
      return theme.enabledCurrencies.map(currency => "".concat(currency.iso_code, " (").concat(currency.symbol, ")"));
    }

    return store.supportedCurrencies.split(',').map(currency => currency);
  }
  /**
   * Returns the supported currencies values for the store.
   * @param {Object} store - Store object from multi-store config.
   * @returns {Array}
   */


  function getSupportedCurrencyValues(store) {
    if (theme.features.currencyConverter) {
      return store.supportedCurrencies.split(', ');
    }

    const storeCode = getDefaultStoreCode();

    if (store.storeCode === storeCode) {
      return theme.enabledCurrencies.map(currency => currency.iso_code);
    }

    return store.supportedCurrencies.split(',').map(currency => currency.split(' ')[0]);
  }
  /**
   * Get option templates from array.
   * @param {Array} options - Supported options based on matched store.
   * @returns {String}
   */


  function getOptionTemplate(options, optionValues) {
    const optionValuesData = optionValues ? optionValues : options;
    return options.map((option, index) => {
      return "\n        <option value=\"".concat(optionValuesData[index], "\">\n          ").concat(option, "\n        </option>");
    }).join('');
  }
  /**
   * Hide choice cards and return button.
   */


  function disableChoiceCards() {
    showSettingsView();
    document.querySelector(selectors.footer).classList.add(cssClasses.hidden);
    document.querySelector(selectors.returnButton).classList.add(cssClasses.hidden);
  }
  /**
   * Check if click target is continue browsing choice.
   * @param {Object} target - Click target on container.
   * @returns {Boolean}
   */


  function isContinueBrowsingButton(target) {
    return typeof target.attributes[dataSelectors.redirectModal] !== 'undefined' && target.getAttribute(dataSelectors.redirectModal) === 'choiceContinue';
  }
  /**
   * Check if click target is a view settings button.
   * @param {Object} target - Click target on container.
   * @returns {Boolean}
   */


  function isViewSettingsButton(target) {
    return typeof target.attributes[dataSelectors.redirectModal] !== 'undefined' && target.getAttribute(dataSelectors.redirectModal) === 'settingsButton';
  }
  /**
   * Check if click target is a view choices button.
   * @param {Object} target - Click target on container.
   * @returns {Boolean}
   */


  function isReturnButton(target) {
    return typeof target.attributes[dataSelectors.redirectModal] !== 'undefined' && target.getAttribute(dataSelectors.redirectModal) === 'returnButton';
  }
  /**
   * Check if click target is a redirect choice button.
   * @param {Object} target - Click target on container.
   * @returns {Boolean}
   */


  function isRedirectChoice(target) {
    return typeof target.attributes[dataSelectors.redirectModal] !== 'undefined' && target.getAttribute(dataSelectors.redirectModal) === 'redirectLink';
  }
  /**
   * Check if click target is a close button.
   * @param {Object} target - Click target on container.
   * @returns {Boolean}
   */


  function isCloseButton(target) {
    return typeof target.attributes[dataSelectors.redirectModal] !== 'undefined' && target.getAttribute(dataSelectors.redirectModal) === 'close';
  }
  /**
   * Handle settings view when toggled.
   */


  function showSettingsView() {
    const choiceContainer = document.querySelector(selectors.choiceContainer);
    const settingsContainer = document.querySelector(selectors.settingsContainer);
    choiceContainer.classList.add(cssClasses.hidden);
    settingsContainer.classList.remove(cssClasses.hidden);
    updateTabindexOnElement(choiceContainer, -1);
    updateTabindexOnElement(settingsContainer, 0);
  }
  /**
   * Handle settings view when toggled.
   */


  function showChoicesView() {
    const choiceContainer = document.querySelector(selectors.choiceContainer);
    const settingsContainer = document.querySelector(selectors.settingsContainer);
    choiceContainer.classList.remove(cssClasses.hidden);
    settingsContainer.classList.add(cssClasses.hidden);
    updateTabindexOnElement(choiceContainer, 0);
    updateTabindexOnElement(settingsContainer, -1);
  }
  /**
   * Handle continue button choice click.
   * @param {Event} event - Click target of continue link.
   */


  function handleContinueClick(event) {
    event.preventDefault();
    Cookies.set(cookieSelector.modal, 'dismissed', {
      expires: 7
    });
    window.setTimeout(() => disableChoiceCards(), 1500);
  }
  /**
   * Handle parameter events when url string contains all parameters.
   * @param {String} query - Query parameter string.
   */


  function handleParameterEvents(query) {
    Cookies.set(cookieSelector.settings, query);
    Cookies.set(cookieSelector.modal, 'dismissed', {
      expires: 7
    });
    disableChoiceCards();
  }
  /**
   * Handle cookie and events based on location query string.
   * - Get query parameters and update store settings cookie.
   * - Update store icon with `Redirects:updateIcon` event.
   */


  function handleLocationParameterEvents() {
    const queryParameters = getQueryParamsObject();

    if (queryParameters.loc) {
      Frame.EventBus.emit(eventSelector.redirectIcon, queryParameters.loc.toLowerCase());
      const storeSettings = Cookies.getJSON(cookieSelector.settings);
      const selectedCountryName = getCountryNameFromCode(queryParameters.loc);
      const newSettings = Object.assign(storeSettings, {
        loc: queryParameters.loc.toLowerCase(),
        countryName: selectedCountryName
      });
      Cookies.set(cookieSelector.settings, newSettings);
    }
  }
  /**
   * Manually handle redirect link click.
   * - Use form data for redirect url query string.
   * @param {Event} event - Click target of redirect link.
   */


  function handleRedirectClick(event) {
    const countryCode = event.target.dataset.redirectStoreCode.toUpperCase();
    const params = "\n      loc=".concat(countryCode, "&\n      cur=").concat(Currency().getSupportedCurrencies(countryCode).split(',')[0], "&\n      lang=").concat(getDefaultLanguageCode(countryCode), "\n    ").replace(/\s/g, '');
    event.preventDefault();
    Cookies.set(cookieSelector.modal, 'dismissed', {
      expires: 7
    });
    window.location = "".concat(event.target.href, "?").concat(params);
  }
  /**
   * Replace country code in title and body content.
   * Placeholder options defined in settings.
   * @param {Object} response - GeoIP response from `redirect.js`.
   */


  function render(response) {
    renderPlaceholderText(response);
  }
  /**
   * Replace location references in modal container.
   * @param {Object} response - Redirect store response defined in `redirect.js`.
   */


  function renderPlaceholderText(response) {
    const updateButton = document.querySelector(selectors.updateButton);
    let matchingStore = response.matchingStore.storeCode;
    let countryCode = null;

    if (window.location.href.includes('?loc=')) {
      if (window.location.href.split('?loc=')[1].substring(0, 3) === 'ROW') {
        countryCode = 'ROW';
      } else {
        countryCode = window.location.href.split('?loc=')[1].substring(0, 2);
      }

      window.Frame.MultiStore.forEach(store => {
        if (!store.supportedStores.includes(countryCode)) {
          return;
        }

        matchingStore = store.storeCode;
      });
    }

    updateButton.setAttribute('data-current-country', matchingStore);
    /**
     * Replace choice content.
     */

    container.innerHTML = container.innerHTML.replace(placeholder.redirectStoreUrl, response.matchingStore.storeUrl);
    container.innerHTML = container.innerHTML.replace(new RegExp(placeholder.redirectStoreCode, 'g'), response.location.countryCode.toLowerCase());
    /**
     * Replace current location content.
     */

    container.innerHTML = container.innerHTML.replace(new RegExp(placeholder.redirectStoreName, 'g'), response.location.countryName);
  }
  /**
   * Handle close callback function by setting cookie.
   */


  function handleCloseButtonEvent() {
    modal.close(settings.id);
    handleCloseEvents();
  }
  /**
   * Handle close callback function by setting cookie.
   */


  function handleCloseEvents() {
    Cookies.set(cookieSelector.modal, 'dismissed', {
      expires: 7
    });
  }
  /**
   * Handle open callback function by trapping focus on active modal card.
   */


  function handleOpenEvents() {
    const visibleContainers = [...container.querySelector('[js-modal="body"]').children].filter(element => !element.classList.contains(cssClasses.hidden))[0];
    const invisibleContainers = [...container.querySelector('[js-modal="body"]').children].filter(element => element.classList.contains(cssClasses.hidden))[0];
    updateTabindexOnElement(visibleContainers, 0);
    updateTabindexOnElement(invisibleContainers, -1);
  }
  /**
   * Update currency selector to use default selected currency in settings.
   * @param {String} currencyCode - Currency to select.
   */


  function updateSelectedCurrencyOption(currencyCode) {
    if (!currencyCode) {
      return;
    }

    const currencySelector = document.querySelector(selectors.currencySelector);
    const selectedOption = [...currencySelector.children].find(option => option.value === currencyCode);

    if (typeof selectedOption === 'undefined') {
      return;
    }

    document.querySelector(selectors.currencySelector).selectedIndex = selectedOption.index;
  }
  /**
   * Update language selector to use default selected language in settings.
   */


  function updateSelectedLanguageOption() {
    const selectedLanguage = getDefaultLanguageCode();
    const languageSelector = document.querySelector(selectors.languageSelector);
    const selectedOption = [...languageSelector.children].find(option => option.value === selectedLanguage);

    if (typeof selectedOption === 'undefined') {
      return;
    }

    document.querySelector(selectors.languageSelector).selectedIndex = selectedOption.index;
  }
  /**
   * Get store and country code using theme settings and cookies.
   * @returns {String}
   */


  function getDefaultStoreCode() {
    if (typeof Cookies.getJSON(cookieSelector.settings) !== 'undefined') {
      return Cookies.getJSON(cookieSelector.settings).loc.toUpperCase();
    }

    return theme.store.storeCode === 'EU' ? 'FR' : theme.store.storeCode;
  }
  /**
   * Get country name from country selector using country code.
   * @param {String} countryCode - Country code to filter values against.
   * @returns {String}
   */


  function getCountryNameFromCode(countryCode) {
    return [...document.querySelector(selectors.countrySelector).children].find(element => {
      return element.value === countryCode.toUpperCase();
    }).text;
  }
  /**
   * Get default language setting.
   * @param {String} storeCode - Store code to find in multi-store configuration.
   * @returns {String}
   */


  function getDefaultLanguageCode(storeCode) {
    if (storeCode) {
      const matchingStore = Redirects().getMatchingStore(storeCode);
      return matchingStore.supportedLanguages.split(',')[0];
    }

    if (typeof Cookies.getJSON(cookieSelector.settings) !== 'undefined') {
      return Cookies.getJSON(cookieSelector.settings).lang;
    }

    const languageSelector = document.querySelector(selectors.languageSelector);
    return languageSelector.options[languageSelector.selectedIndex].value;
  }
  /**
   * Update form button to use loading state and disable.
   * @param {HTMLElement} button - Targeted form button.
   */


  function setButtonLoadingState(button) {
    button.setAttribute('disabled', true);
    button.classList.add(cssClasses.disabled);
    button.innerHTML = "<span>".concat(theme.redirect.updating, "</span>");
  }
  /**
   * Return form button to active state and enable.
   * @param {HTMLElement} button - Targeted form button.
   */


  function setButtonActiveState(button) {
    button.removeAttribute('disabled');
    button.classList.remove(cssClasses.disabled);
    button.innerHTML = theme.redirect.updatePreferences;
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init
  });
});